import { useTranslation } from "react-i18next";
import type { ExpertReview } from "./expert-review/expert-review.types";
import { RatingWithLaurel } from "./expert-review/rating-with-laurel.component";

type ProductDetailsCTAExpertReviewProps = {
	expertReview: ExpertReview;
	onClick?: () => void;
};

export function ProductDetailsCTAExpertReview({
	expertReview,
	onClick,
}: ProductDetailsCTAExpertReviewProps) {
	const { t } = useTranslation("product");

	return (
		<>
			<button
				type="button"
				onClick={onClick}
				className="flex flex-col gap-1 items-center cursor-pointer bg-transparent border-0 p-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ansay-main focus-visible:ring-offset-2 rounded-md"
				data-testid="expert-review-cta"
				aria-label={t("expertReview.ctaLabel")}
			>
				<RatingWithLaurel rating={expertReview.overallRating} size="sm" />
				<span className="text-caption text-center text-gray-700">
					{t("expertReview.ctaLabel")}
				</span>
			</button>
			<div className="h-12 border-l border-gray-200" />
		</>
	);
}
